<template>
  <form class="main-modal" v-if="office">
    <div class="main-modal__title">
      <p>Niederlassung hinzufügen</p>
    </div>

    <div class="main-form__box">
      <span class="main-form__label">Niederlassung:</span>

      <Select2
        v-if="filteredList"
        :options="filteredList"
        v-model="office.office_id"
        :settings="{ placeholder: 'Niederlassung' }"
        v-validate="{ required: true }"
        name="slug"
        class="select2-container_w100"
        style="width: 100%"
      />
    </div>

    <div class="main-form__box main-form__box_flex">
      <div class="main-form__half main-form__half_first">
        <span class="main-form__label">{{ $t("services.serviceCost") }}:</span>

        <input type="text" class="main-form__input" v-model="office.price" />
      </div>

      <div class="main-form__half main-form__half_second">
        <span class="main-form__label">{{ $t("forms.price15") }}:</span>
        <label>
          <input
            type="text"
            class="main-form__input"
            v-model="office.price_fifteen"
            :placeholder="$t('forms.price15')"
          />
        </label>
      </div>
    </div>

    <div class="main-form__box main-form__box_flex">
      <div class="main-form__half main-form__half_first">
        <span class="main-form__label">Aufpreis 1: (%)</span>
        <label>
          <input
            type="text"
            class="main-form__input"
            v-model="office.percent_extra_price_1"
            :placeholder="'Aufpreis 1 (%)'"
          />
        </label>
      </div>

      <div class="main-form__half main-form__half_second">
        <span class="main-form__label">Aufpreis 2: (%)</span>
        <label>
          <input
            type="text"
            class="main-form__input"
            v-model="office.percent_extra_price_2"
            :placeholder="'Aufpreis 2 (%)'"
          />
        </label>
      </div>
    </div>

    <div class="main-form__buttons main-form__buttons_center">
      <span class="main-button main-button_cancel">Abbrechen</span>
      <button
        class="main-button main-button_success"
        type="reset"
        @click="addPrices"
        :disabled="!isValid"
      >Ändern</button>
    </div>
  </form>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'office-price-modal',
    props: {
        office: {
            required: true,
        },
    },
    computed: {
        ...mapGetters({
            filteredList: 'offices/filteredList',
        }),
        isValid() {
            if (this.office.price === 0) return false
            return !(this.office.office_id === null || this.office.office_id === '')
        },
    },
    methods: {
        addPrices() {
            this.office.address = this.filteredList.filter(
                (item) => this.office.office_id === item.id,
            )

            this.$emit('done', {
                office_id: this.office.office_id,
                address: this.office.address[0].text,
                price: +this.office.price,
                price_fifteen: +this.office.price_fifteen,
                percent_extra_price_1: +this.office.percent_extra_price_1,
                percent_extra_price_2: +this.office.percent_extra_price_2,
            })
        },
    },
}
</script>
